import { useEffect, useState } from "react";
import { useParams, useNavigate, generatePath } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Button, Form } from "react-bootstrap";
import Header from "./Header";
import Sidebar from "./Sidebar.js";
//  import DataGridTable from "./common/DataGridTable";
import DynamicTable from "./common/DynamicTable";
import http from "../api/server.js";
import Footer from "./Footer";
import BottomBarIcons from "./BottomBarIcons";
import * as XLSX from "xlsx";
import StatusPill from "./common/StatusPill";
import { IconButton } from "@mui/material";
import {
  GET_RMS_USER_CONTACT_COUNT,
  TRIGGER_EMAIL_TO_RESIDENT_USERS,
  GET_RMS_USER_INFO_LIST,
  DOWNLOAD_RESIDENT_NOTIFICATION_LETTER,
  CREATE_RMS_POST_DETAILS,
  TRIGGER_EMAIL_TO_SEND_BOOKING_LINK,
} from "../api/apiPath.js";
import Toaster from "./common/Toaster";
import SidebarIcons from "./SidebarIcons.js";
import DynamicTiles from "../components/common/DynamicTiles.js";
import LoadingComponent from "./common/LoadingComponent";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import downloadIcon from "../assets/img/excleExport.png";
import { useSelector } from "react-redux";
import ClearIcon from "@mui/icons-material/Clear";
import sendemailLogo from "../assets/img/emailblack.png";
import sendbookingLogo from "../assets/img/bookingListblack.png";

import sendemailLogoicon from "../assets/img/emailred.png";
import sendbookingLogoicon from "../assets/img/genletter.png";

import searchIcon from "../assets/img/searchIcon.png";
import followupIcon from "../assets/img/followup.png";
import followupblackIcon from "../assets/img/followupblack.png";
import activeEditIcon from "../assets/img/activeEditIcon.png";
import activeHistoryIcon from "../assets/img/activeHistoryIcon.png";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import AutocompleteInput from "./common/AutocompleteInput";

const LeadDashboard = () => {
  const { clientNameParam } = useParams();
  const navigate = useNavigate();
  const [countData, setCountData] = useState({});
  const [searchText, setSearchText] = useState("");
  const [blockManager, setBlockManager] = useState("Block Manager");
  const [city, setCity] = useState("City");
  const [email, setEmail] = useState("Email");
  const [name, setName] = useState("Name");
  const [userInfoList, setUserInfoList] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [showEmailConfirmation, setShowEmailConfirmation] = useState(false);
  const [hideSidebar, setHideSidebar] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [postedBy, setPostedBy] = useState("");
  const [postedOn, setPostedOn] = useState("");
  const today = new Date().toISOString().split("T")[0];
  const [trackingReferenceNumber, setTrackingReferenceNumber] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const [selectedRows, setSelectedRows] = useState([]);
  // const [showManualUpdateModal, setShowManualUpdateModal] = useState(false);
  const [showManualFollowUp, setShowManualFollowUp] = useState(false);
  const [manualFollowUpRow, setManualFollowUpRow] = useState(null);

  const [manualFollowUpData, setManualFollowUpData] = useState({
    followUpType: "",
    callStatus: "",
    followUpDate: "",
    comment: "",
  });
  const [manualFollowUpError, setManualFollowUpError] = useState({
    followUpDate: false,
  });

  // emailType read for booking popup (emailType === "booking"); setter was only used for reminder popup (now commented)
  // eslint-disable-next-line no-unused-vars
  const [emailType, setEmailType] = useState(""); // "normal" or "booking"
  const { userObj } = useSelector((state) => state.user);

  const [bookingFormData, setBookingFormData] = useState({
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
  });
  const [bookingErrorData, setBookingErrorData] = useState({
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
  });
  // Per-day slots for booking window: { [date: 'YYYY-MM-DD']: { startTime: 'HH:MM', endTime: 'HH:MM' } }
  const [bookingSlotsByDate, setBookingSlotsByDate] = useState({});

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };
  const resetBookingModal = () => {
    setShowEmailConfirmation(false);

    setBookingFormData({
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: "",
    });

    setBookingErrorData({
      startDate: false,
      endDate: false,
      startTime: false,
      endTime: false,
    });
    setBookingSlotsByDate({});
  };
  const nameList = [
    ...new Set(
      userInfoList.map((user) => `${user.firstName} ${user.lastName}`),
    ),
  ].map((item) => ({ name: item }));

  const emailList = [
    ...new Set(
      userInfoList
        .map((user) => user.email)
        .filter((email) => email && email.trim() !== ""),
    ),
  ].map((item) => ({ name: item }));

  const cityList = [
    ...new Set(userInfoList.map((user) => user.city).filter(Boolean)),
  ].map((item) => ({ name: item }));

  const blockManagerList = [
    ...new Set(userInfoList.map((user) => user.createdBy).filter(Boolean)),
  ].map((item) => ({ name: item }));
  const isAnyFilterApplied =
    searchText !== "" ||
    blockManager !== "Block Manager" ||
    city !== "City" ||
    email !== "Email" ||
    name !== "Name";

  useEffect(() => {
    const fetchContactCount = async () => {
      try {
        const response = await http.get(GET_RMS_USER_CONTACT_COUNT);
        setCountData(response.data);
      } catch (error) {
        console.error("Error fetching contact count:", error);
      }
    };

    fetchContactCount();
    fetchUserInfoList();
  }, []);

  const fetchUserInfoList = async () => {
    try {
      const response = await http.get(GET_RMS_USER_INFO_LIST);
      // setUserInfoList(response.data);
      const sortedData = [...response.data].sort(
        (a, b) => new Date(b.createdOn) - new Date(a.createdOn),
      );

      setUserInfoList(sortedData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching user info list:", error);
    }
  };

  const handleExportToExcel = () => {
    const exportData = filteredRows.map((row) => ({
      Name: `${row.firstName} ${row.lastName}`,
      Email: row.email,
      PhoneNumber: row.phoneNumber,
      PropertyDetails: `${row.propertyName}, ${row.apartmentOrHouseNo}, ${row.propertyAddress}, ${row.city}, ${row.postCode}`,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "resident-export.xlsx");

    setToastData({
      toastShow: true,
      toastType: "success",
      toastString: "Excel file downloaded successfully.",
    });
  };

  const resetManualFollowUp = () => {
    setShowManualFollowUp(false);
    setManualFollowUpData({
      followUpDate: "",
      comment: "",
    });
    setManualFollowUpError({
      followUpDate: false,
    });
  };

  // useEffect(() => {
  //   if (!selectedIds.length) {
  //     setSelectedRows([]);
  //     return;
  //   }

  //   const mapped = userInfoList.filter((row) =>
  //     selectedIds.includes(row.rmsUserInfoId),
  //   );

  //   setSelectedRows(mapped);
  // }, [selectedIds, userInfoList]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const open = Boolean(anchorEl);

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const getResidentTableColumns = () => [
    // { field: "firstName", headerName: "NAME", flex: 1, headerClassName: "header-bold" },

    {
      field: "actions",
      headerName: "ACTIONS",
      headerClassName: "header-bold super-app-theme--header",
      sortable: false,
      filterable: false,
      flex: 0.3,
      width: 120,
      minWidth: 120,
      // renderCell: (params) => (
      //   <Box>
      //     <img
      //       title="Edit"
      //       alt="Edit"
      //       src={activeEditIcon}
      //       style={{ cursor: "pointer", justifyItems: "center" }}
      //       onClick={() => handleEditClick(params.row)}
      //     ></img>
      //     <img
      //       alt="Generate Letter"
      //       src={sendbookingLogoicon}
      //       title="Generate Letter"
      //       style={{ cursor: "pointer", justifyItems: "center" }}
      //       onClick={() => {
      //         generateLetter(params?.row?.rmsUserInfoId);
      //       }}
      //     ></img>
      //     <img
      //       alt="Send Email"
      //       src={sendemailLogoicon}
      //       title="Send Email Reminder"
      //       style={{ cursor: "pointer", justifyItems: "center" }}
      //       onClick={() => {
      //         setSelectedIds([params?.row?.rmsUserInfoId]);
      //         setShowEmailConfirmation(true);
      //       }}
      //     ></img>
      //     <img
      //       tabIndex={0}
      //       title="Resident Log"
      //       alt="Resident Log"
      //       onClick={() => gotoLogPage(params?.row)}
      //       src={activeHistoryIcon}
      //       style={{ cursor: "pointer" }}
      //     ></img>
      //     <img
      //       // className="fa fa-regular fa-edit vividOrangeColor px-2"
      //       title=" Manual FollowUp Update"
      //       alt="Manual Follow Update"
      //       src={followupIcon}
      //       style={{ cursor: "pointer", justifyItems: "center" }}
      //       onClick={() => {
      //         setSelectedIds([params?.row?.rmsUserInfoId]);
      //         setShowManualFollowUp(true);
      //         setManualFollowUpRow(params.row);
      //         setTrackingReferenceNumber(
      //           params.row.trackingReferenceNumber || "",
      //         );
      //       }}
      //     ></img>
      //   </Box>
      // ),

      renderCell: (params) => (
        <IconButton size="small" onClick={(e) => handleMenuOpen(e, params.row)}>
          <MoreVertIcon />
        </IconButton>
      ),
      renderHeader: () => (
        <span style={{ display: "flex", alignItems: "center" }}>
          <span className="personalFont">Actions</span>

          <i
            className="bi bi-info-circle"
            style={{
              fontSize: "0.9rem",
              marginLeft: "5px",
              cursor: "pointer",
            }}
            title="Click the three dots menu for each resident to access edit resident details, resident log, generate letter and create RMS link for each resident."
          ></i>
        </span>
      ),
    },
    {
      field: "name",
      headerName: "Name",
      headerClassName: "header-bold super-app-theme--header",
      sortable: false,
      flex: 1,
      renderCell: (params) => `${params.row.firstName}  ${params.row.lastName}`,
    },
    {
      field: "email",
      headerName: "EMAIL",
      flex: 1,
      headerClassName: "header-bold super-app-theme--header",
    },
    {
      field: "phoneNumber",
      headerName: "PHONE NO.",
      flex: 1,
      headerClassName: "header-bold super-app-theme--header",
    },
    {
      field: "propertyDetails",
      headerName: "PROPERTY DETAILS",
      headerClassName: "header-bold super-app-theme--header",
      sortable: false,
      flex: 2,
      renderCell: (params) =>
        `${params.row.propertyName}, ${params.row.apartmentOrHouseNo},${params.row.propertyAddress}, ${params.row.city}, ${params.row.postCode}`,
    },
    {
      field: "status",
      width: 140,
      height: 50,
      headerName: "STATUS",
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 140,
      flex: 0.7,
      renderCell: (params) =>
        params.value ? (
          <StatusPill status={params.value} row={params.row} />
        ) : null,
    },
    {
      field: "reminderSentBy",
      headerName: "Reminder Sent By",
      flex: 1,
      headerClassName: "header-bold super-app-theme--header",
      renderCell: (params) => params.row.reminderSentBy,
    },
    {
      field: "reminderSentOn",
      headerName: "Reminder Sent On",
      flex: 1,
      headerClassName: "header-bold super-app-theme--header",
      renderCell: (params) =>
        // params.row.reminderSentOn
        //   ? new Date(params.row.reminderSentOn).toLocaleDateString()
        params.row.reminderSentOn
          ? new Date(params.row.reminderSentOn).toLocaleDateString("en-US", {
              month: "2-digit",
              day: "2-digit",
              year: "2-digit",
            })
          : null,
    },
  ];
  const filteredRows = userInfoList.filter((row) => {
    const matchesSearch =
      !searchText ||
      row.firstName?.toLowerCase().includes(searchText.toLowerCase()) ||
      row.lastName?.toLowerCase().includes(searchText.toLowerCase()) ||
      row.email?.toLowerCase().includes(searchText.toLowerCase()) ||
      row.phoneNumber?.toLowerCase().includes(searchText.toLowerCase()) ||
      row.propertyName?.toLowerCase().includes(searchText.toLowerCase()) ||
      row.propertyAddress?.toLowerCase().includes(searchText.toLowerCase()) ||
      row.apartmentOrHouseNo
        ?.toLowerCase()
        .includes(searchText.toLowerCase()) ||
      row.postCode?.toLowerCase().includes(searchText.toLowerCase()) ||
      row.city?.toLowerCase().includes(searchText.toLowerCase());

    const matchesBlockManager =
      blockManager === "Block Manager" || row.createdBy === blockManager;

    const matchesCity = city === "City" || row.city === city;

    const matchesEmail = email === "Email" || row.email === email;

    const matchesName =
      name === "Name" || `${row.firstName} ${row.lastName}` === name;

    return (
      matchesSearch &&
      matchesBlockManager &&
      matchesCity &&
      matchesEmail &&
      matchesName
    );
  });

  const generateLetter = async (userId) => {
    try {
      if (!userId) return;
      setLoading(true);
      const response = await http.get(
        `${DOWNLOAD_RESIDENT_NOTIFICATION_LETTER}?rmsUserInfoId=${userId}&emailAddress=${userObj.userEmail}`,
        {
          responseType: "blob", // Important for file download
        },
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Resident_Notification_Letter.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error generating letter:", error);
      const errmsg =
        error?.data?.message ||
        " There is no inspection created for this property.";
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: errmsg,
      });
    } finally {
      setLoading(false);
    }
  };
  // const sendEmail = async (userIds = [], type = "reminder") => {

  //   try {
  //     if (!Array.isArray(userIds) || userIds.length === 0) return;
  //     let endpoint =
  //       type === "booking"
  //         ? TRIGGER_EMAIL_TO_SEND_BOOKING_LINK
  //         : TRIGGER_EMAIL_TO_RESIDENT_USERS;
  //     const response = await http.post(endpoint, userIds);
  //     if (!response.status || response.status >= 400) {
  //       setToastData({
  //         toastShow: true,
  //         toastType: "failure",
  //         toastString: "Error in sending email, please try again later",
  //       });
  //     }else{
  //       setToastData({
  //         toastShow: true,
  //         toastType: "success",
  //         toastString: "Email sent successfully",
  //       });
  //     }

  //     console.log("Email triggered successfully:", response.data);
  //   } catch (error) {
  //     console.error("Error triggering email:", error);
  //     setToastData({
  //       toastShow: true,
  //       toastType: "failure",
  //       toastString: "Error in sending email, please try again later",
  //     });
  //   }
  // };
  // const getSelectedPropertyName = () => {
  //   const selectedRows = userInfoList.filter((row) =>
  //     selectedIds.includes(row.rmsUserInfoId),
  //   );

  //   const uniqueProperties = [
  //     ...new Set(selectedRows.map((row) => row.propertyName)),
  //   ];

  //   return uniqueProperties[0] || "";
  // };
  const handleManualFollowUpSubmit = async () => {
    if (!manualFollowUpRow) return;
    if (!manualFollowUpData.followUpDate) {
      setManualFollowUpError({ followUpDate: true });
      return;
    }

    const payload = {
      refNo: trackingReferenceNumber,
      recipientEmail: manualFollowUpRow.email,
      manualFollowUpType: manualFollowUpData.followUpType,
      manualFollowUpOutcome: manualFollowUpData.callStatus,
      manualFollowUpDate: manualFollowUpData.followUpDate,
      manualFollowUpComment: manualFollowUpData.comment,
      loggedInUserEmail: userObj.userEmail,
    };

    const apiUrl = `/manual-follow-up?subdomain=${clientNameParam}`;

    try {
      const response = await http.post(apiUrl, payload);
      const errmsg =
        response?.data?.message || "Manual Follow-up updated successfully";
      setToastData({
        toastShow: true,
        toastType: "success",
        toastString: errmsg,
      });

      setShowManualFollowUp(false);
      setManualFollowUpData({ comment: "", followUpDate: "" });
      fetchUserInfoList();
    } catch (error) {
      console.error("Manual follow-up error:", error);
      const errmsg =
        error?.data?.message ||
        "Error in updating manual follow-up, please try again later";
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: errmsg,
      });
    }
  };

  const sendEmail = async (userIds = [], type = "reminder") => {
    try {
      if (!Array.isArray(userIds) || userIds.length === 0) return;
      let endpoint =
        type === "booking"
          ? TRIGGER_EMAIL_TO_SEND_BOOKING_LINK
          : TRIGGER_EMAIL_TO_RESIDENT_USERS;
      let payload;
      if (type === "booking") {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
          setBookingErrorData(validationErrors);
          return;
        } else {
          payload = {
            rmsIds: userIds,
            loggedInUserEmail: userObj.userEmail,
            propertyName: "",
            startDate: bookingFormData.startDate,
            endDate: bookingFormData.endDate,
            startTime: convertToISOTimeFormat(bookingFormData.startTime) || "",
            endTime: convertToISOTimeFormat(bookingFormData.endTime) || "",
          };
          // Build optional per-day slots array so backend can use specific slots per date
          const dates = generateDateRange(
            bookingFormData.startDate,
            bookingFormData.endDate,
          );
          let slots = [];

          if (dates.length > 0) {
            if (
              bookingSlotsByDate &&
              Object.keys(bookingSlotsByDate).length > 0
            ) {
              // Use explicit per-day slots where provided
              slots = dates
                .map((date) => {
                  const slot = bookingSlotsByDate[date];
                  if (!slot || !slot.startTime || !slot.endTime) return null;
                  return {
                    date,
                    startTime: convertToISOTimeFormat(slot.startTime),
                    endTime: convertToISOTimeFormat(slot.endTime),
                  };
                })
                .filter(Boolean);
            } else {
              // Fallback: apply the single time window to all days (previous behavior)
              if (bookingFormData.startTime && bookingFormData.endTime) {
                slots = dates.map((date) => ({
                  date,
                  startTime: convertToISOTimeFormat(bookingFormData.startTime),
                  endTime: convertToISOTimeFormat(bookingFormData.endTime),
                }));
              }
            }
          }

          if (slots.length > 0) {
            payload.slots = slots;
          }
        }
      } else {
        payload = {
          rmsIds: userIds,
          loggedInUserEmail: userObj.userEmail,
        };
      }
      console.log(
        "Sending email to endpoint:",
        endpoint,
        "with userIds:",
        userIds,
      );
      const response = await http.post(endpoint, payload);
      const errmsg = response?.data?.message || "Link sent successfully";
      if (!response.status || response.status >= 400) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: errmsg,
        });
      } else {
        setToastData({
          toastShow: true,
          toastType: "success",
          // toastString: "Booking Email Sent Successfully",
          toastString: errmsg,
        });
      }
      setShowEmailConfirmation(false);
      console.log("Email triggered successfully:", response.data);
    } catch (error) {
      console.error("Error triggering email:", error);
      const errmsg =
        error?.data?.message ||
        "Error in sending email, please try again later";
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: errmsg,
      });
      setShowEmailConfirmation(false);
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedIds((prevSelected) => {
      if (prevSelected.includes(id)) {
        // Remove ID if already selected
        return prevSelected.filter((item) => item !== id);
      } else {
        // Add ID if not selected
        return [...prevSelected, id];
      }
    });
  };

  const handleBookingDataChange = (field, e) => {
    setBookingFormData((prevData) => ({
      ...prevData,
      [field]: e.target.value,
    }));
    setBookingErrorData((prevErrors) => ({
      ...prevErrors,
      [field]: e.target.value ? "" : prevErrors[field],
    }));
  };

  function convertToISOTimeFormat(time) {
    const [hh, mm] = time.split(":");
    const ss = "00";
    const mmm = "000";

    return `${hh}:${mm}:${ss}.${mmm}`;
  }

  // Generate an inclusive list of dates (YYYY-MM-DD) between startDate and endDate
  const generateDateRange = (startDate, endDate) => {
    if (!startDate || !endDate) return [];
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (
      Number.isNaN(start.getTime()) ||
      Number.isNaN(end.getTime()) ||
      start > end
    ) {
      return [];
    }
    const dates = [];
    const current = new Date(start);
    while (current <= end) {
      dates.push(current.toISOString().split("T")[0]);
      current.setDate(current.getDate() + 1);
    }
    return dates;
  };

  const handleSlotChange = (date, field, value) => {
    setBookingSlotsByDate((prev) => ({
      ...prev,
      [date]: {
        ...(prev?.[date] || {}),
        [field]: value,
      },
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!bookingFormData.startDate)
      newErrors.startDate = "Start Date is required";
    if (!bookingFormData.endDate) newErrors.endDate = "End Date is required";
    if (!bookingFormData.startTime)
      newErrors.startTime = "Start Time is required";
    if (!bookingFormData.endTime) newErrors.endTime = "End Time is required";

    return newErrors;
  };

  const applyDefaultSlotToAllDays = () => {
    // Reuse existing validation to ensure main fields are filled first
    const errors = validate();
    if (Object.keys(errors).length > 0) {
      setBookingErrorData(errors);
      return;
    }
    const { startDate, endDate, startTime, endTime } = bookingFormData;
    const dates = generateDateRange(startDate, endDate);
    const slots = {};
    dates.forEach((d) => {
      slots[d] = {
        startTime,
        endTime,
      };
    });
    setBookingSlotsByDate(slots);
  };

  const clearAllSlots = () => {
    setBookingSlotsByDate({});
  };

  const renderPerDaySlots = () => {
    const { startDate, endDate } = bookingFormData;
    const dates = generateDateRange(startDate, endDate);

    if (!dates || dates.length === 0) return null;

    return (
      <>
        <hr className="mt-3 mb-2" />
        <p className="small mb-2">
          Day-wise time slots (optional). Use the buttons below to apply the
          above time to all days, then adjust individual days if needed.
        </p>
        <div className="d-flex gap-2 mb-2 flex-wrap">
          <button
            type="button"
            className="btn-secondary btn-sm"
            onClick={applyDefaultSlotToAllDays}
          >
            Apply above time to all days
          </button>
          <button
            type="button"
            className="btn-secondary btn-sm"
            onClick={clearAllSlots}
          >
            Clear all day-wise slots
          </button>
        </div>
        <div className="day-slots-list">
          {dates.map((date) => {
            const slot = bookingSlotsByDate?.[date] || {
              startTime: "",
              endTime: "",
            };
            const displayLabel = new Date(date).toLocaleDateString("en-GB", {
              weekday: "short",
              day: "numeric",
              month: "short",
              year: "numeric",
            });
            return (
              <div
                key={date}
                className="form-group d-flex flex-wrap gap-2 align-items-end mb-2"
              >
                <div className="flex-grow-1">
                  <label className="mb-1">Date</label>
                  <input
                    type="text"
                    className="form-control"
                    value={displayLabel}
                    disabled
                  />
                </div>
                <div>
                  <label className="mb-1">Start time</label>
                  <input
                    type="time"
                    className="form-control"
                    value={slot.startTime}
                    onChange={(e) =>
                      handleSlotChange(date, "startTime", e.target.value)
                    }
                  />
                </div>
                <div>
                  <label className="mb-1">End time</label>
                  <input
                    type="time"
                    className="form-control"
                    value={slot.endTime}
                    onChange={(e) =>
                      handleSlotChange(date, "endTime", e.target.value)
                    }
                  />
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  };

  const handleEditClick = (row) => {
    setEditData({
      name: `${row.firstName} ${row.lastName}`,
      email: row.email,
      phoneNumber: row.phoneNumber,
      propertyDetails: `${row.propertyName}, ${row.apartmentOrHouseNo}, ${row.propertyAddress}, ${row.city}, ${row.postCode}`,
      // generatedDate:
      //   row.generatedOn != null
      //     ? new Date(row.generatedOn).toLocaleDateString()
      //     : "",
      generatedDate:
        row.generatedOn != null
          ? new Date(row.generatedOn)
              .toLocaleDateString("en-US", {
                month: "2-digit",
                day: "2-digit",
                year: "2-digit",
              })
              .replace(/\//g, "-")
          : "",
      generatedBy: row.generatedBy,
      postedBy: row.postedBy,
      postedOn: row.postedOn,
      rmsUserInfoId: row.rmsUserInfoId,
    });
    setPostedBy(row.postedBy || "");
    setPostedOn(
      row.postedOn ? new Date(row.postedOn).toISOString().split("T")[0] : "",
    );
    setTrackingReferenceNumber(row.trackingReferenceNumber || "");
    setShowEditModal(true);
  };

  const handleEditSubmit = async () => {
    setIsSubmitting(true);
    try {
      await http.post(CREATE_RMS_POST_DETAILS, {
        rmsUserInfoId: editData.rmsUserInfoId,
        postedBy,
        postedOn,
        trackingReferenceNumber,
      });
      setShowEditModal(false);
      fetchUserInfoList();
    } catch (error) {
      console.error("Error submitting edit:", error);
      const errmsg =
        error?.data?.message ||
        "Error in submitting details, please try again later";
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: errmsg,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const gotoLogPage = (rowData) => {
    let pathTemplate;

    pathTemplate = "/client/:clientNameParam/residentLog";

    const params = {
      clientNameParam: clientNameParam,
    };

    const fullPath = generatePath(pathTemplate, params);

    navigate(fullPath, {
      state: {
        selectedRow: rowData,
      },
    });
  };

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      <LoadingComponent loading={loading} />
      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={() => {
          closeButton();
        }}
      />

      <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        <MenuItem
          onClick={() => {
            handleEditClick(selectedRow);
            handleMenuClose();
          }}
        >
          <img src={activeEditIcon} width={18} style={{ marginRight: 8 }} />
          Edit
        </MenuItem>

        <MenuItem
          onClick={() => {
            generateLetter(selectedRow?.rmsUserInfoId);
            handleMenuClose();
          }}
        >
          <img
            src={sendbookingLogoicon}
            width={18}
            style={{ marginRight: 8 }}
          />
          Generate Letter
        </MenuItem>

        <MenuItem
          onClick={() => {
            sendEmail([selectedRow?.rmsUserInfoId], "reminder");
            handleMenuClose();
          }}
        >
          <img src={sendemailLogoicon} width={18} style={{ marginRight: 8 }} />
          Send Email Reminder
        </MenuItem>

        <MenuItem
          onClick={() => {
            gotoLogPage(selectedRow);
            handleMenuClose();
          }}
        >
          <img src={activeHistoryIcon} width={18} style={{ marginRight: 8 }} />
          Resident Log
        </MenuItem>

        <MenuItem
          onClick={() => {
            setSelectedIds([selectedRow?.rmsUserInfoId]);
            setShowManualFollowUp(true);
            setManualFollowUpRow(selectedRow);
            setTrackingReferenceNumber(
              selectedRow?.trackingReferenceNumber || "",
            );
            handleMenuClose();
          }}
        >
          <img src={followupIcon} width={18} style={{ marginRight: 8 }} />
          Manual Follow-Up Update
        </MenuItem>
      </Menu>
      <div className="dashboard_body_main">
        {/* Header */}

        {hideSidebar ? (
          <Sidebar setHideSidebar={setHideSidebar} hideSidebar={hideSidebar} />
        ) : (
          <SidebarIcons
            setHideSidebar={setHideSidebar}
            hideSidebar={hideSidebar}
          />
        )}

        <div
          className="d-flex dashboard_body flex-column py-1 w-100 mt-2"
          //style={{ marginTop: "123px !important", marginBottom: "75px" }} //paddingLeft: "120px", paddingRight: "50px" }}
        >
          {/* Stats Cards */}
          <Row className="g-3 mb-3">
            <Col md={4}>
              <div
                className="p-2 bg-white text-center"
                style={{ border: "1px solid #D4D4D4", borderRadius: "10px" }}
              >
                <span style={{ fontSize: "2.8rem", fontWeight: "600" }}>
                  {countData.emptyContactCount}
                </span>
                <p className="mb-0">
                  Residents without phone and email address
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div
                className="p-2 bg-white text-center"
                style={{ border: "1px solid #D4D4D4", borderRadius: "10px" }}
              >
                <span style={{ fontSize: "2.8rem", fontWeight: "600" }}>
                  {countData.availablePhoneCount}
                </span>
                <p className="mb-0">Residents with phone only</p>
              </div>
            </Col>
            <Col md={4}>
              <div
                className="p-2 bg-white text-center"
                style={{ border: "1px solid #D4D4D4", borderRadius: "10px" }}
              >
                <span style={{ fontSize: "2.8rem", fontWeight: "600" }}>
                  {countData.availableEmailCount}
                </span>
                <p className="mb-0">Residents with email address only</p>
              </div>
            </Col>
          </Row>
          <div className="p-3 rounded-4 orange-box">
            <Row className="g-3">
              {/* Generate Letter */}
              <Col md={6}>
                <div className="d-flex flex-column align-items-center text-center p-3 justify-content-center rounded-3 h-100 property-card">
                  {/* <i
                    className="fa-regular fa-file-text mb-3 vividOrangeColor"
                    style={{ fontSize: "40px" }}
                  /> */}
                  <img
                    src={sendbookingLogo}
                    style={{ height: "50px" }}
                    className="mb-3"
                    alt="Send booking link"
                  />
                  <h6 className="text-black fw-bold">Send Booking Link</h6>
                  <p className="text-grey small mb-3">
                    Broadcast booking link for residents
                  </p>
                  <Button
                    className="px-4 fw-semibold red-button"
                    disabled={selectedIds.length === 0}
                    style={{ height: "fit-content" }}
                    onClick={() => {
                      navigate(
                        generatePath(
                          "/client/:clientNameParam/sendBookingLink",
                          { clientNameParam },
                        ),
                        { state: { selectedIds } },
                      );
                    }}
                  >
                    Send Booking Link
                  </Button>
                </div>
              </Col>

              {/* Send Email */}
              <Col md={6}>
                <div className="d-flex flex-column align-items-center text-center p-3 justify-content-center rounded-3 h-100 property-card">
                  {/* <i
                    className="fa-regular fa-envelope mb-3 vividOrangeColor"
                    style={{ fontSize: "40px" }}
                  /> */}
                  <img
                    src={sendemailLogo}
                    style={{ height: "48px" }}
                    className="mb-3"
                    alt="Send Email Reminder"
                  />
                  <h6 className="text-black fw-bold">Send Email Reminder</h6>
                  <p className="text-grey small mb-3">
                    Broadcast email communications for residents
                  </p>
                  <Button
                    className="px-4 fw-semibold red-button"
                    onClick={() => {
                      // OLD: opened popup; now call API directly and show toaster
                      // setEmailType("remainder");
                      // setShowEmailConfirmation(true);
                      sendEmail(selectedIds, "reminder");
                    }}
                    disabled={selectedIds.length === 0}
                  >
                    Send Email Reminder
                  </Button>

                  {/* <ol>
                                    {selectedIds.length > 0 && (
                                        selectedIds.map((id) => (
                                            <li className="text-danger" key={id}>{id}</li>
                                        ))
                                    )}
                                </ol> */}
                </div>
              </Col>
            </Row>
          </div>

          <div className="dashboard-bar py-3">
            {/* <div className="d-flex justify-content-between">
              <h2 className="mt-0 mb-3 text-start fw-bold">Resident Details</h2>
              <div className="col-md-2 text-end ">
                <button
                  className="btn btn-primary px-3 custom_toolbar_btn"
                  disabled={selectedIds.length === 0}
                  onClick={() => setShowManualFollowUp(true)}
                >
                  <i
                    className="fa-solid fa-pen"
                    style={{ marginRight: "5px" }}
                  ></i>
                  Manual Follow Update
                </button>
              </div>
              <div className="col-md-2 text-end">
                <button
                  className="btn btn-primary px-3 custom_toolbar_btn"
                  onClick={() => handleExportToExcel()}
                >
                  <i
                    className="fa-solid fa-download"
                    style={{ marginRight: "5px" }}
                  ></i>
                  Export to Excel
                </button>
              </div>
            </div> */}

            <div className="d-flex justify-content-between align-items-center">
              <h2 className="mt-0 mb-3 text-start fw-bold">Resident Details</h2>

              <div className="d-flex align-items-center gap-2">
                <Tooltip
                  title="View Booking Reports"
                  arrow
                  slotProps={{
                    tooltip: {
                      sx: {
                        bgcolor: "#fff",
                        color: "#000",
                        fontSize: "12px",
                        boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "#fff",
                      },
                    },
                  }}
                >
                  <button
                    className="btn btn-primary px-3 custom_toolbar_btn"
                    onClick={() => {
                      const path = generatePath(
                        "/client/:clientNameParam/viewAllReport",
                        {
                          clientNameParam: clientNameParam,
                        },
                      );

                      navigate(path);
                    }}
                  >
                    View Booking Reports
                  </button>
                </Tooltip>
                <Tooltip
                  title="Manual Follow-Up Update"
                  arrow
                  slotProps={{
                    tooltip: {
                      sx: {
                        bgcolor: "#fff",
                        color: "#000",
                        fontSize: "12px",
                        boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "#fff",
                      },
                    },
                  }}
                >
                  <button
                    className="btn btn-primary px-3 custom_toolbar_btn"
                    disabled={selectedIds.length !== 1}
                    onClick={() => {
                      const row = userInfoList.find(
                        (r) => r.rmsUserInfoId === selectedIds[0],
                      );

                      if (!row) {
                        // console.warn("No row found for selected ID");
                        return;
                      }

                      setManualFollowUpRow(row);
                      setTrackingReferenceNumber(
                        row.trackingReferenceNumber || "",
                      );
                      setShowManualFollowUp(true);
                    }}
                  >
                    {/* <i className="fa-solid fa-pen me-1"></i>
                     */}
                    <img
                      src={followupblackIcon}
                      alt="Edit"
                      style={{
                        width: "18px",
                        height: "18px",
                        marginRight: "6px",
                        verticalAlign: "middle",
                      }}
                    />
                    {/* Manual Follow Update */}
                    Manual Follow-Up Update
                  </button>
                </Tooltip>
                <Tooltip
                  title="Export to Excel"
                  arrow
                  slotProps={{
                    tooltip: {
                      sx: {
                        bgcolor: "#fff",
                        color: "#000",
                        fontSize: "12px",
                        boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "#fff",
                      },
                    },
                  }}
                >
                  <button
                    // className="btn btn-primary px-3 custom_toolbar_btn"
                    className="btn btn-outline"
                    onClick={handleExportToExcel}
                  >
                    <img src={downloadIcon}></img>
                    {/* Export to Excel */}
                  </button>
                </Tooltip>
              </div>
            </div>

            <div className="row align-items-center g-3">
              {/* Search Bar */}

              <div className="custom_toolbar_search col-md-3 ">
                <img src={searchIcon} />
                <input
                  type="text"
                  className="form-control custom_toolbar_control"
                  id="floatingInput"
                  placeholder="Search..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>

              {/* Dropdowns */}
              <div className="col-6 col-md-2">
                {/* <select
                  className="form-select custom_toolbar_control"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                >
                  <option value="Name">Name</option>
                  {[
                    ...new Set(
                      userInfoList.map(
                        (user) => `${user.firstName} ${user.lastName}`,
                      ),
                    ),
                  ].map((fullName, index) => (
                    <option key={index} value={fullName}>
                      {fullName}
                    </option>
                  ))}
                </select> */}

                <AutocompleteInput
                  masterList={nameList}
                  getOptionLabel={(item) => item?.name || ""}
                  getOptionValue={(item) => item?.name || ""}
                  value={name === "Name" ? "" : name}
                  onValueChange={(value) => setName(value || "Name")}
                  placeholder="Name"
                  inputClassName="form-control custom_toolbar_control"
                  notFoundText="Name not found"
                />
              </div>

              <div className="col-6 col-md-2">
                {/*                
                <select
                  className="form-select custom_toolbar_control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                >
                  <option value="Email">Email</option>
                 
                  {[
                    ...new Set(
                      userInfoList
                        .map((user) => user.email)
                        .filter((email) => email && email.trim() !== ""),
                    ),
                  ].map((emailItem, index) => (
                    <option key={index} value={emailItem}>
                      {emailItem}
                    </option>
                  ))}
                </select> */}
                <AutocompleteInput
                  masterList={emailList}
                  getOptionLabel={(item) => item?.name || ""}
                  getOptionValue={(item) => item?.name || ""}
                  value={email === "Email" ? "" : email}
                  onValueChange={(value) => setEmail(value || "Email")}
                  placeholder="Email"
                  inputClassName="form-control custom_toolbar_control"
                  notFoundText="Email not found"
                />
              </div>
              <div className="col-6 col-md-2">
                {/* <select
                  className="form-select custom_toolbar_control"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                >
                  <option value="City">City</option>
                  {[...new Set(userInfoList.map((user) => user.city))].map(
                    (cityItem, index) => (
                      <option key={index} value={cityItem}>
                        {cityItem}
                      </option>
                    ),
                  )}
                </select> */}

                <AutocompleteInput
                  masterList={cityList}
                  getOptionLabel={(item) => item?.name || ""}
                  getOptionValue={(item) => item?.name || ""}
                  value={city === "City" ? "" : city}
                  onValueChange={(value) => setCity(value || "City")}
                  placeholder="City"
                  inputClassName="form-control custom_toolbar_control"
                  notFoundText="City not found"
                />
              </div>
              <div className="col-6 col-md-2">
                {/* <select
                  className="form-select custom_toolbar_control"
                  value={blockManager}
                  onChange={(e) => setBlockManager(e.target.value)}
                >
                  <option>Block Manager</option>
                  {[...new Set(userInfoList.map((user) => user.createdBy))].map(
                    (createdByItem, index) => (
                      <option key={index} value={createdByItem}>
                        {createdByItem}
                      </option>
                    ),
                  )}
                </select> */}

                <AutocompleteInput
                  masterList={blockManagerList}
                  getOptionLabel={(item) => item?.name || ""}
                  getOptionValue={(item) => item?.name || ""}
                  value={blockManager === "Block Manager" ? "" : blockManager}
                  onValueChange={(value) =>
                    setBlockManager(value || "Block Manager")
                  }
                  placeholder="Block Manager"
                  inputClassName="form-control custom_toolbar_control"
                  notFoundText="Block Manager not found"
                />
              </div>

              {isAnyFilterApplied && (
                <div style={{ width: "auto", paddingLeft: "0px" }}>
                  <IconButton
                    tabIndex={0}
                    title="Clear Filters"
                    onClick={() => {
                      setSearchText("");
                      setBlockManager("Block Manager");
                      setCity("City");
                      setEmail("Email");
                      setName("Name");
                    }}
                  >
                    <ClearIcon sx={{ color: "#717186" }} fontSize="small" />
                  </IconButton>
                </div>
              )}
              {/* Export Button */}
            </div>
          </div>

          {/* <DataGridTable
          tableData={filteredRows}
          setSelectedIds={setSelectedIds}
          setShowEmailConfirmation={setShowEmailConfirmation}
          module="leadDashboard"
        /> */}
          <div className="inspection-table">
            <DynamicTable
              tableData={filteredRows}
              module="leadDashboard"
              columnsValue={getResidentTableColumns()}
              showSelectAll={true}
              rowHeight={45}
              setSelectedIds={setSelectedIds}
              //handleCheckBoxSelection={handleMultipleUserDelete}
              pageSize={10}
              pageSizeOptions={[100, 150, 200, { value: -1, label: "All" }]}
            />
          </div>

          <div className="inspection-tile">
            {filteredRows &&
              filteredRows?.map((item) => {
                return (
                  // eslint-disable-next-line react/jsx-key
                  <DynamicTiles
                    tableData={item}
                    selectedIds={selectedIds}
                    setSelectedIds={setSelectedIds}
                    setShowEmailConfirmation={setShowEmailConfirmation}
                    handleCheckboxChange={handleCheckboxChange}
                    module="leadDashboard"
                  />
                );
              })}
          </div>
        </div>
        <Footer />
        <div className="bottom-bar-spacing"></div>
        <BottomBarIcons />
      </div>
      {showManualFollowUp && (
        <div className="modal-overlay">
          <div className="approval-modal-content" style={{ height: "auto" }}>
            <i
              className="fa-solid fa-xmark fa-sm close-icon mt-2"
              style={{ cursor: "pointer" }}
              // onClick={() => setShowManualFollowUp(false)}
              onClick={resetManualFollowUp}
            ></i>

            <div className="modal-body p-3">
              <span>
                Please enter follow-up details for selected residents :
              </span>
              <div className="form-group mt-3">
                <label htmlFor="followUpType">Follow-up Type</label>
                <select
                  id="followUpType"
                  required
                  className="form-select w-100 mb-2"
                  // value={manualFollowUpData.followUpType}
                  onChange={(e) =>
                    setManualFollowUpData({
                      ...manualFollowUpData,
                      followUpType: e.target.value,
                      callStatus: "",
                    })
                  }
                >
                  <option value="">Select follow-up type</option>
                  <option value="sms">SMS</option>
                  <option value="call">Call</option>
                  <option value="whatsapp">WhatsApp</option>
                </select>
              </div>
              {manualFollowUpData.followUpType === "call" && (
                <div className="form-group mt-2 mb-2">
                  <label htmlFor="callStatus">Call Status</label>
                  <select
                    id="callStatus"
                    required
                    className="form-select w-100"
                    value={manualFollowUpData.callStatus}
                    onChange={(e) =>
                      setManualFollowUpData({
                        ...manualFollowUpData,
                        callStatus: e.target.value,
                      })
                    }
                  >
                    <option value="">Select call status</option>
                    <option value="reachable">Reachable</option>
                    <option value="attended">Attended</option>
                    <option value="not_reachable">Not Reachable</option>
                    <option value="no_answer">Not Attended / No Answer</option>
                    <option value="busy">Busy</option>
                    <option value="disconnected">Disconnected</option>
                    <option value="callback_requested">
                      Call Back Requested
                    </option>
                    <option value="switched_off">Switched Off</option>
                    <option value="invalid_number">Invalid Number</option>
                    <option value="wrong_number">Wrong Number</option>
                  </select>
                </div>
              )}

              <div className="form-group">
                <label htmlFor="followUpDate">
                  Follow-up Date <span className="label-star">*</span>
                </label>
                <input
                  type="date"
                  id="followUpDate"
                  required
                  className={
                    manualFollowUpError.followUpDate
                      ? "form-control w-100 input-error"
                      : "form-control w-100"
                  }
                  value={manualFollowUpData.followUpDate}
                  onChange={(e) =>
                    setManualFollowUpData({
                      ...manualFollowUpData,
                      followUpDate: e.target.value,
                    })
                  }
                />
              </div>

              <div className="card-body mt-2">
                {/* Comment */}
                <div className="form-group">
                  <label htmlFor="comment">Comment</label>
                  <textarea
                    id="comment"
                    className="form-control w-100"
                    placeholder="Enter follow-up comment"
                    value={manualFollowUpData.comment}
                    onChange={(e) =>
                      setManualFollowUpData({
                        ...manualFollowUpData,
                        comment: e.target.value,
                      })
                    }
                  />
                </div>
              </div>

              <div className="mt-3 card-body action_btns d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap">
                <button
                  type="reset"
                  className="btn-secondary"
                  // onClick={() => setShowManualFollowUp(false)}
                  onClick={resetManualFollowUp}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn-primary"
                  onClick={() => {
                    handleManualFollowUpSubmit();
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showEmailConfirmation && emailType === "booking" && (
        <div className="modal-overlay">
          <div
            className="approval-modal-content"
            style={{ height: "auto", width: "90%", maxWidth: "1000px" }}
          >
            <i
              className="fa-solid fa-xmark fa-sm close-icon mt-2"
              style={{ cursor: "pointer" }}
              // onClick={() => setShowEmailConfirmation(false)}
              onClick={resetBookingModal}
            ></i>
            <div className="modal-body p-3">
              <span>
                Please select start and end dates to send the booking link to
                residents :
              </span>

              <div className="card-body-section mt-2">
                <div className="form-group">
                  <label
                    htmlFor="startDate"
                    // className="form-label text-start d-block fw-semibold"
                  >
                    Start date <span className="label-star">*</span>
                  </label>
                  <input
                    className={bookingErrorData.startDate ? "input-error" : ""}
                    type="date"
                    id="startDate"
                    required
                    min={today}
                    placeholder="Start Date"
                    value={bookingFormData.startDate}
                    onChange={(e) => {
                      handleBookingDataChange("startDate", e);
                    }}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="endDate">
                    End date <span className="label-star">*</span>
                  </label>
                  <input
                    className={bookingErrorData.endDate ? "input-error" : ""}
                    type="date"
                    id="endDate"
                    required
                    min={today}
                    placeholder="End Date"
                    value={bookingFormData.endDate}
                    onChange={(e) => {
                      handleBookingDataChange("endDate", e);
                    }}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="startTime">
                    Start time <span className="label-star">*</span>
                  </label>
                  <input
                    className={bookingErrorData.startTime ? "input-error" : ""}
                    type="time"
                    id="startTime"
                    required
                    placeholder="Start Time"
                    value={bookingFormData.startTime}
                    onChange={(e) => {
                      handleBookingDataChange("startTime", e);
                    }}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="endTime">
                    End time <span className="label-star">*</span>
                  </label>
                  <input
                    className={bookingErrorData.endTime ? "input-error" : ""}
                    type="time"
                    id="endTime"
                    required
                    placeholder="End Time"
                    value={bookingFormData.endTime}
                    onChange={(e) => {
                      handleBookingDataChange("endTime", e);
                    }}
                  />
                </div>
                {renderPerDaySlots()}
              </div>

              <div className="mt-3 card-body action_btns d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap">
                <button
                  type="reset"
                  className="btn-secondary"
                  // onClick={() => setShowEmailConfirmation(false)}
                  onClick={resetBookingModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn-primary"
                  onClick={() => {
                    sendEmail(selectedIds, emailType); // Pass type if needed
                    resetBookingModal();
                  }}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* OLD: Reminder popup - commented out; Send Email button now calls API directly and shows toaster
      {showEmailConfirmation && emailType !== "booking" && (
        <div className="modal-overlay">
          <div
            className="approval-modal-content"
            style={{ height: "auto", width: "90%", maxWidth: "1000px" }}
          >
            <i
              className="fa-solid fa-xmark fa-sm close-icon mt-2"
              style={{ cursor: "pointer" }}
              onClick={resetBookingModal}
            ></i>
            <div className="modal-body p-3">
              <span>
                Please select start and end dates to send the booking link to
                residents :
              </span>

              <div className="card-body-section mt-2">
                <div className="form-group">
                  <label htmlFor="startDate">
                    Start date <span className="label-star">*</span>
                  </label>
                  <input
                    className={bookingErrorData.startDate ? "input-error" : ""}
                    type="date"
                    id="startDate"
                    min={today}
                    required
                    placeholder="Start Date"
                    value={bookingFormData.startDate}
                    onChange={(e) => {
                      handleBookingDataChange("startDate", e);
                    }}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="endDate">
                    End date <span className="label-star">*</span>
                  </label>
                  <input
                    className={bookingErrorData.endDate ? "input-error" : ""}
                    type="date"
                    id="endDate"
                    required
                    min={today}
                    placeholder="End Date"
                    value={bookingFormData.endDate}
                    onChange={(e) => {
                      handleBookingDataChange("endDate", e);
                    }}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="startTime">
                    Start time <span className="label-star">*</span>
                  </label>
                  <input
                    className={bookingErrorData.startTime ? "input-error" : ""}
                    type="time"
                    id="startTime"
                    required
                    placeholder="Start Time"
                    value={bookingFormData.startTime}
                    onChange={(e) => {
                      handleBookingDataChange("startTime", e);
                    }}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="endTime">
                    End time <span className="label-star">*</span>
                  </label>
                  <input
                    className={bookingErrorData.endTime ? "input-error" : ""}
                    type="time"
                    id="endTime"
                    required
                    placeholder="End Time"
                    value={bookingFormData.endTime}
                    onChange={(e) => {
                      handleBookingDataChange("endTime", e);
                    }}
                  />
                </div>
              </div>

              <div className="mt-3 card-body action_btns d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap">
                <button
                  type="reset"
                  className="btn-secondary"
                  onClick={resetBookingModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn-primary"
                  onClick={() => {
                    sendEmail(selectedIds, emailType);
                    setShowEmailConfirmation(false);
                    resetBookingModal();
                  }}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      */}

      {showEditModal && (
        <div className="modal-overlay">
          <div className="approval-modal-content" style={{ height: "auto" }}>
            <span
              className="close"
              onClick={() => {
                setShowEditModal();
              }}
            >
              &times;
            </span>
            <h6 className="modal-header p-2">Manage Resident Details</h6>
            <div className="modal-body p-3">
              {editData && (
                <Form>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-2">
                        <Form.Label className="text-start w-100">
                          Name
                        </Form.Label>
                        <Form.Control value={editData.name} disabled />
                      </Form.Group>

                      <Form.Group className="mb-2">
                        <Form.Label className="text-start w-100">
                          Phone
                        </Form.Label>
                        <Form.Control value={editData.phoneNumber} disabled />
                      </Form.Group>
                      <Form.Group className="mb-2">
                        <Form.Label className="text-start w-100">
                          Generated Date
                        </Form.Label>
                        <Form.Control value={editData.generatedDate} disabled />
                      </Form.Group>
                      <Form.Group className="mb-2">
                        <Form.Label className="text-start w-100">
                          Generated By
                        </Form.Label>
                        <Form.Control value={editData.generatedBy} disabled />
                      </Form.Group>
                      <Form.Group className="mb-2">
                        <Form.Label className="text-start w-100">
                          Posted Date
                        </Form.Label>
                        {/* <Form.Control
                          type="date"
                          value={postedOn}
                          onChange={(e) => setPostedOn(e.target.value)}
                        /> */}
                        <DatePicker
                          selected={postedOn ? new Date(postedOn) : null}
                          onChange={(date) =>
                            setPostedOn(
                              // date ? date.toISOString().split("T")[0] : "",
                              date
                                ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
                                : "",
                            )
                          }
                          dateFormat="MM-dd-yy"
                          className="form-control"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-2">
                        <Form.Label className="text-start w-100">
                          Email
                        </Form.Label>
                        <Form.Control value={editData.email} disabled />
                      </Form.Group>
                      <Form.Group className="mb-2">
                        <Form.Label className="text-start w-100">
                          Property Details
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          value={editData.propertyDetails}
                          disabled
                        />
                      </Form.Group>

                      <Form.Group className="mb-2">
                        <Form.Label className="text-start w-100">
                          Posted By
                        </Form.Label>
                        <Form.Control
                          value={postedBy}
                          onChange={(e) => setPostedBy(e.target.value)}
                          placeholder="Enter posted by"
                        />
                      </Form.Group>
                      <Form.Group className="mb-2">
                        <Form.Label className="text-start w-100">
                          Tracking Reference Number
                        </Form.Label>
                        <Form.Control
                          value={trackingReferenceNumber}
                          onChange={(e) =>
                            setTrackingReferenceNumber(e.target.value)
                          }
                          placeholder="Enter tracking reference number"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              )}
              <div className="card-body action_btns d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap">
                <Button
                  variant="secondary"
                  onClick={() => setShowEditModal(false)}
                  disabled={isSubmitting}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={handleEditSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Manage Resident Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editData && (
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-2">
                    <Form.Label className="text-start w-100">Name</Form.Label>
                    <Form.Control value={editData.name} disabled />
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label className="text-start w-100">Phone</Form.Label>
                    <Form.Control value={editData.phoneNumber} disabled />
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label className="text-start w-100">
                      Generated Date
                    </Form.Label>
                    <Form.Control value={editData.generatedDate} disabled />
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label className="text-start w-100">
                      Generated By
                    </Form.Label>
                    <Form.Control value={editData.generatedBy} disabled />
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label className="text-start w-100">
                      Posted Date
                    </Form.Label>
                    <Form.Control
                      type="date"
                      value={postedOn}
                      onChange={(e) => setPostedOn(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-2">
                    <Form.Label className="text-start w-100">Email</Form.Label>
                    <Form.Control value={editData.email} disabled />
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label className="text-start w-100">
                      Property Details
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      value={editData.propertyDetails}
                      disabled
                    />
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label className="text-start w-100">
                      Posted By
                    </Form.Label>
                    <Form.Control
                      value={postedBy}
                      onChange={(e) => setPostedBy(e.target.value)}
                      placeholder="Enter posted by"
                    />
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label className="text-start w-100">
                      Tracking Reference Number
                    </Form.Label>
                    <Form.Control
                      value={trackingReferenceNumber}
                      onChange={(e) =>
                        setTrackingReferenceNumber(e.target.value)
                      }
                      placeholder="Enter tracking reference number"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowEditModal(false)}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleEditSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal> */}
    </>
  );
};
export default LeadDashboard;
